<template>
  <p>{{ profileName }}</p>
</template>

<script>
export default {
  props: ["profileName"],
};
</script>
